import { render, staticRenderFns } from "./AddRateChange.vue?vue&type=template&id=06ef77a8&scoped=true&"
import script from "./AddRateChange.vue?vue&type=script&lang=js&"
export * from "./AddRateChange.vue?vue&type=script&lang=js&"
import style0 from "./AddRateChange.vue?vue&type=style&index=0&id=06ef77a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef77a8",
  null
  
)

export default component.exports